const Pan: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="38"
      height="38"
      fill="none"
      viewBox="0 0 38 38"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        fill="currentColor"
        d="M12.6652 7.9165V15.8332H15.8319V7.9165H12.6652ZM6.33187 9.49984V15.8332H9.49854V9.49984H6.33187ZM18.9985 9.49984V15.8332H22.1652V9.49984H18.9985ZM29.3273 14.2498C27.8282 14.253 26.5517 15.3176 26.238 16.7578L25.7524 18.9998H0.0078125L1.71484 27.5381C2.0099 29.0071 3.32088 30.0832 4.81966 30.0832H24.033C25.5318 30.0832 26.8428 29.0071 27.1379 27.5381L27.1348 27.5628L29.3335 17.432C29.3363 17.4187 29.3443 17.4165 29.3335 17.4165H37.9985V14.2498H29.3304H29.3273ZM3.87028 22.1665H25.0628L24.0361 26.9041L24.033 26.9165H4.81966L3.87028 22.1665Z"
      />
    </svg>
  );
};

export default Pan;
